<template>
  <b-button
    class="delete-button"
    :class="variant == 'primary' ? 'button-blue' : 'button-danger'"
  >
    <i
      class="fa fa-trash delete-icon"
      :class="variant == 'primary' ? 'icon-blue' : 'icon-danger'"
    ></i>
  </b-button>
</template>

<script>
export default {
  props: ["variant"],
  data() {
    return {};
  },
};
</script>

<style>
.delete-icon {
  font-size: 24px !important;
  cursor: pointer;
  transition: all 0.2s;
}
.icon-danger {
  color: #ff3d60;
}
.icon-blue {
  color: rgb(86, 100, 210) !important;
}
.delete-button {
  background-color: inherit;
  border-radius: 10px;
  padding: 10px;
  border: 0px;
  transition: all 0.2s;
  width: 45px;
  height: 45px;
}
.delete-button:hover .delete-icon {
  transform: scale(1.3);
}
.button-danger:hover {
  background-color: rgba(255, 61, 96, 0.1) !important;
}
.button-blue:hover {
  background-color: rgba(86, 100, 210, 0.1) !important;
}
</style>
